import React, { FC } from 'react'
import { ISelectOption } from 'components/forms/Selects'
import { InputMultiSelect } from 'transfix-ui/components/InputMultiSelect'
import { $enum } from 'ts-enum-util'
import { IFilters } from 'apps/edi-tools/types'
import { TextInput } from 'components/atoms'
import { DatePicker } from 'components/forms'

interface IProps {
  filters: IFilters
  applyFilters: Function
}

export enum EDI_FILE_TYPE_NAMES {
  'Functional Acknowledgement' = 'functional_acknowledgement',
  'Invoice' = 'invoice',
  'Invoice Update' = 'invoice_update',
  'Scheduled Status Message' = 'scheduled_status_message',
  'Shipper Functional Acknowledgement' = 'shipper_functional_acknowledgement',
  'Spot Load Response' = 'spot_load_response',
  'Status Message' = 'status_message',
  'Tendered Load' = 'tendered_load',
  'Tendered Load Response' = 'tendered_load_response',
}

export const filtersDefaults: IFilters = {
  shipperId: '',
  shipmentId: '',
  fileTypes: [],
  createdBeforeDate: '',
}

export const Filters: FC<IProps> = ({ applyFilters, filters }) => {
  const shipperIdChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) =>
    applyFilters({ shipperId: e.target.value })

  const shipmentIdChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) =>
    applyFilters({ shipmentId: e.target.value })

  const EDIFileTypeChangeHandler = (options: ISelectOption[]) => {
    applyFilters({ fileTypes: options.map(o => o.value) })
  }

  const createdBeforeDateChangeHandler = (selectedDate: string[]) =>
    applyFilters({ createdBeforeDate: selectedDate[0] })

  return (
    <div>
      {/* TODO: add some spacing / adjust the filters layout */}
      <h3>Filter</h3>
      <hr />
      <TextInput
        clearable
        id='filterShipmentId'
        label='Shipment'
        placeholder='Shipment ID'
        onChange={shipmentIdChangeHandler}
      />
      <br />
      <TextInput
        clearable
        id='filterShipperId'
        label='Shipper'
        placeholder='Shipper ID'
        onChange={shipperIdChangeHandler}
      />
      <span>EDI Message Type</span>
      <InputMultiSelect
        options={$enum(EDI_FILE_TYPE_NAMES).map((value, label) => ({ label, value }))}
        values={filters.fileTypes}
        onChange={EDIFileTypeChangeHandler}
      />
      <span>Created before</span>
      <DatePicker onDateChange={createdBeforeDateChangeHandler} placeholder='Created before date' />
    </div>
  )
}
